import { prodEnv } from './.env';

export const environment = {
  production: prodEnv.production,
  apiHost: prodEnv.apiHost,
  baseUrl: prodEnv.baseUrl,
  analyticsId: prodEnv.analyticsId,
  gaId: prodEnv.gaId,
  googleAdsId: prodEnv.googleAdsId,
  googleAdsTelConversion: prodEnv.googleAdsTelConversion,
  googleTagManagerId: prodEnv.googleTagManagerId,
  yahooYdnConvIo: prodEnv.yahooYdnConvIo,
  yahooYdnConvLabel: prodEnv.yahooYdnConvLabel,
  defaultLang: prodEnv.defaultLang,
  facebookAppId: prodEnv.facebookAppId,
  facebookAdsId: prodEnv.facebookAdsId,
};
